<template>
  <div class="geo-popup" v-click-outside="closePopup">
    <button class="modal__close" @click="$emit('closePopup')"></button>
    <span class="geo-popup__title">{{ $t('your_city') }}</span>
    <div class="geo-popup__single-city">
      <span class="geo-popup__city-name"
      >{{ potentialUserCity.name }}?</span
      >
      <Button class="geo-popup__apply" @click.native="sendCity">{{ $t('apply_city') }}</Button>
    </div>
    <button class="link link--pseudo" @click="showModal">
      {{ $t('select_another') }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Button from '../inputs/Button'
import vClickOutside from 'v-click-outside'

export default {
  name: 'GeoPopup',
  components: { Button },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      potentialUserCity: state => state.geoLocation.potentialUserCity
    })
  },
  methods: {
    ...mapActions(['SEND_USER_CITY']),
    closePopup () {
      this.$emit('closePopup')
    },
    sendCity () {
      this.SEND_USER_CITY(this.potentialUserCity.city_id)
      this.$emit('closePopup')
    },
    showModal () {
      this.$modal.show('geo-modal')
      this.$emit('closePopup')
    }
  }
}
</script>

<style scoped lang="sass">

.geo-popup
  padding: 20px 0
  top: 90px
  left: 50%
  transform: translateX(-50%)
  position: fixed
  background: #fff
  width: 220px
  border-radius: 3px
  box-shadow: 0 4px 7px rgba(181, 181, 181, 0.25)
  z-index: 5
  display: flex
  flex-direction: column
  align-items: center

  +mmin(1024)
    padding: 20px 0 16px
    position: absolute
    top: 20px
    left: auto
    transform: translateX(-33%)

.geo-popup__apply
  font-size: 14px
  font-family: 'Cera Pro', Roboto, Helvetica, Arial, sans-serif
  margin: 20px
  padding: 6px 30px
  width: 180px

  +mmin(1024)
    margin: 20px auto 10px

.geo-popup__title
  font-size: 14px
  color: $nd-label-color
  margin-bottom: 10px

.geo-popup__city-name
  color: $text-color
  font-weight: 500
  display: block
  max-width: 160px
  overflow-wrap: break-word

.link
  text-decoration: underline
  border: 0
  font-size: 13px
  background: transparent
  font-family: 'Cera Pro', Roboto, Helvetica, Arial, sans-serif

  &:hover
    border-bottom: 0 !important

.geo-popup__single-city
  display: flex
  flex-direction: column
  align-items: center
  width: 100%

.geo-popup__multiple-cities
  width: 100%

.geo-popup__cities-list
  padding: 0
  margin: 15px 0

.geo-popup__cities-list-item
  padding: 10px 20px
  font-size: 14px
  list-style: none
  color: $text-color
  cursor: pointer

  &:hover
    background: #f2f2f2
    color: $main-color

.modal__close
  display: none
  +mmin(1024)
    display: block
    top: 15px
    right: 15px
</style>
